import styled from '@emotion/styled';
import { COLOR_VARIANTS, color } from '@tajawal/ct-web-design-system';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 24px;
  min-height: 332px;
  border-radius: 12px;
  border: 1px solid ${color(COLOR_VARIANTS.GAINSBORO)};
  background: ${color(COLOR_VARIANTS.WHITE)};
  margin-bottom: 32px;
  align-self: center;
`;

export default { Wrapper };
